import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './App.css';
import MainLayout from './layouts/MainLayout';
import TopicsContainer from './components/TopicsContainer/TopicsContainer';
import NotFound from './components/NotFound';
import Blog from './components/Blog/Blog';
import Statistics from './components/Statistics/Statistics';
import QuizContainer from './components/QuizContainer/QuizContainer';

function App() {
    const router = createBrowserRouter([
        {
            path: '/',
            element: <MainLayout></MainLayout>,
            children: [
                {
                    path: '/',
                    loader: async () => fetch('https://openapi.programming-hero.com/api/quiz'),
                    element: <TopicsContainer></TopicsContainer>,
                },
                {
                    path: "quiz/:quizId",
                    loader: async ({ params }) => fetch(`https://openapi.programming-hero.com/api/quiz/${params.quizId}`),
                    element: <QuizContainer></QuizContainer>,
                },
                {
                    path: 'statistics',
                    loader: async () => fetch('https://openapi.programming-hero.com/api/quiz'),
                    element: <Statistics></Statistics>
                },
                {
                    path: 'blog',
                    element: <Blog></Blog>
                },
                {
                    path: '*',
                    element: <NotFound></NotFound>
                }
            ],
        },
    ]);
    return (
        <div className="">
            <RouterProvider router={router}></RouterProvider>
        </div>
    );
}

export default App;
